export default function () {
  return (x) => {
    console.log(x)
    return x
  }
}
